import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//IE白屏
import 'babel-polyfill'

// element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';


//css
import '../static/icon/iconfont.css'
import '../static/icon/iconfont.js'
import '../static/css/reset.scss'
import '../static/css/redefine-element.scss'
import '../static/css/global.scss'
import '../static/css/common.scss'

//全局
import zzlHttp from './assets/utils/http';
import zzlApi from './assets/providers/api';
import zzlFormat from './assets/utils/format';

//echarts
import echarts from 'echarts'
window.echarts = echarts
Vue.config.productionTip = false


Vue.use(ElementUI);
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});
Vue.prototype.zzlHttp = zzlHttp;
Vue.prototype.zzlApi = zzlApi;
Vue.prototype.zzlFormat = zzlFormat;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
